const styles = {
  container: {
    width: "100%",
  },
  tableBox: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  actionBtn: {
    borderRadius: 0,
    fontSize: 12,
    color: "#FB5C5F",
    backgroundColor: "rgb(242, 242, 242)",
    padding: "2px 8px",
  },
  actionButtons: {
    display: "flex",
    gap: 5,
  },
  actionIcon: {
    cursor: "pointer",
  },
  typoghrphyStyle: {
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: "0.875rem",
  },

  roleChips: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "center",
    borderRadius: "8px",
    marginTop: "4px",
  },
  tableHeadCells: {
    // padding: "8px",
    color: "#000000",
    fontWeight: 600,
    background: "#BAD9EC",
  },
};

export default styles;
